export default __webpack_public_path__ + "static/media/Prompt-SemiBold.2d1180ec.ttf";